import React from "react";
import { Container } from "react-bootstrap";
import PageTitle from "../../components/Elements/PageTitle/PageTitle.tsx";
import FilterInput from "../../components/Filter/FilterInput.tsx";
import SelectFilterFromUrl from "../../components/Filter/SelectFilterFromUrl.tsx";
import SelectNomenclaturesFilter from "../../components/Filter/SelectNomenclaturesFilter.tsx";
import {
  IconDelete,
  IconEdit,
  IconLocation,
  IconOldeb,
} from "../../components/Icon/Icon.tsx";
import useLocalisation, {
  GET_TYPE_GEOMETRY,
} from "../../components/Localisation/useLocalisation.tsx";
import { ActionColumn } from "../../components/Table/columns.tsx";
import QueryTable, {
  useFilterContext,
} from "../../components/Table/QueryTable.tsx";
import { TYPE_BUTTON } from "../../components/Table/TableActionColumn.tsx";
import NOMENCLATURES from "../../enums/NomenclaturesEnum.tsx";
import url from "../../module/fetch.tsx";
import { URLS } from "../../routes.tsx";
import { formatDate } from "../../utils/formatDateUtils.tsx";
import filterValuesToVariable from "./OldebFilter.tsx";

const OldebList = () => {
  const { fetchGeometry } = useLocalisation();

  return (
    <Container>
      <PageTitle
        icon={<IconOldeb />}
        title={"Liste des Obligations Légales de Débroussaillement"}
      />
      <QueryTable
        query={url`/api/oldeb`}
        columns={[
          {
            Header: "Commune",
            accessor: "oldebCommune",
            sortField: "oldebCommune",
            Filter: (
              <SelectFilterFromUrl
                name={"oldebCommune"}
                url={url`/api/commune/get-libelle-commune`}
              />
            ),
          },
          {
            Header: "Section",
            accessor: "oldebSection",
            sortField: "oldebSection",
            Filter: <FilterInput type="text" name="oldebSection" />,
          },
          {
            Header: "Parcelle",
            accessor: "oldebParcelle",
            sortField: "oldebParcelle",
            Filter: <FilterInput type="text" name="oldebParcelle" />,
          },
          {
            Header: "Adresse",
            accessor: "oldebAdresse",
          },
          {
            Header: "Type zone",
            accessor: "oldebTypeZoneUrbanisme",
            sortField: "oldebTypeZoneUrbanisme",
            Filter: (
              <SelectNomenclaturesFilter
                name={"oldebTypeZoneUrbanisme"}
                nomenclature={NOMENCLATURES.OLDEB_TYPE_ZONE_URBANISME}
              />
            ),
          },
          {
            Header: "Dernière visite",
            accessor: "oldebDateDerniereVisite",
            sortField: "oldebDateDerniereVisite",
            Cell: (value) => {
              return (
                <div>{value?.value != null && formatDate(value.value)}</div>
              );
            },
          },
          {
            Header: "Débroussaillement",
            accessor: "oldebTypeDebroussaillement",
            sortField: "oldebTypeDebroussaillement",
            Filter: (
              <SelectNomenclaturesFilter
                name={"oldebTypeDebroussaillement"}
                nomenclature={NOMENCLATURES.OLDEB_TYPE_DEBROUSSAILLEMENT}
              />
            ),
          },
          {
            Header: "Avis",
            accessor: "oldebTypeAvis",
            sortField: "oldebTypeAvis",
            Filter: (
              <SelectNomenclaturesFilter
                name={"oldebTypeAvis"}
                nomenclature={NOMENCLATURES.OLDEB_TYPE_AVIS}
              />
            ),
          },
          ActionColumn({
            Header: "Actions",
            accessor: "oldebId",
            buttons: [
              {
                row: (row) => {
                  return row;
                },
                route: (oldebId) => URLS.OLDEB_UPDATE(oldebId),
                type: TYPE_BUTTON.UPDATE,
                icon: <IconEdit />,
              },
              {
                row: (row) => {
                  return row;
                },
                pathname: url`/api/oldeb/`,
                type: TYPE_BUTTON.DELETE,
                icon: <IconDelete />,
              },
              {
                row: (row: any) => {
                  return row;
                },
                onClick: (oldebId) => {
                  fetchGeometry(
                    GET_TYPE_GEOMETRY.OLDEB,
                    oldebId,
                    URLS.OLDEB_LOCALISATION,
                  );
                },
                type: TYPE_BUTTON.LINK,
                icon: <IconLocation />,
                textEnable: "Localiser",
                classEnable: "primary",
              },
            ],
          }),
        ]}
        idName={"oldebId"}
        filterValuesToVariable={filterValuesToVariable}
        filterContext={useFilterContext({})}
      />
    </Container>
  );
};

export default OldebList;
